import React, { useState } from "react"
import { Link } from 'react-router-dom'

const Footer = () => {
    const [email, setEmail] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [message, setMessage] = useState("")
    const currentYear = new Date().getFullYear()

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault()
        if (!email) return

        setIsSubmitting(true)
        setMessage("")

        try {
            const response = await fetch('/api/newsletter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email })
            })

            const data = await response.json()

            if (response.ok) {
                setMessage("Thank you for subscribing!")
                setEmail("")
                
                // Track Meta Pixel event
                if (typeof window !== 'undefined' && window.fbq) {
                    window.fbq('track', 'Subscribe', {
                        content_name: 'Newsletter Subscription',
                        value: 1.00,
                        currency: 'ZAR'
                    });
                }
            } else {
                setMessage(data.error || "Something went wrong. Please try again.")
            }
        } catch (error) {
            console.error('Newsletter subscription error:', error)
            setMessage("Failed to subscribe. Please try again later.")
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <div className="logo-footer">
                        <Link to="/" className="logo-link">
                            <img 
                                src="/images/logo/RDS Logo.png" 
                                alt="RDS Studio Logo" 
                                className="logo-image-footer"
                                width="100"
                                height="28"
                                onError={(e) => {
                                    e.target.style.display = "none"
                                    e.target.nextElementSibling.style.display = "flex"
                                }}
                            />
                            <div className="logo-fallback-footer" style={{ display: "none" }}>
                                <svg width="30" height="30" viewBox="0 0 40 40" fill="none">
                                    <path d="M8 32V8H20C24.4183 8 28 11.5817 28 16C28 20.4183 24.4183 24 20 24H12V32H8ZM12 12V20H20C22.2091 20 24 18.2091 24 16C24 13.7909 22.2091 12 20 12H12Z" fill="#2DD4BF"/>
                                    <path d="M32 32V8H36C38.2091 8 40 9.79086 40 12V28C40 30.2091 38.2091 32 36 32H32ZM36 12H32V28H36C37.1046 28 38 27.1046 38 26V14C38 12.8954 37.1046 12 36 12Z" fill="#14B8A6"/>
                                </svg>
                            </div>
                        </Link>
                        <div className="logo-text-footer">
                            <div className="logo-text-main-footer">Responsive Design Solutions</div>
                            <div className="logo-text-sub-footer">STUDIO</div>
                        </div>
                    </div>
                    <p>
                        Professional web design, SEO &amp; digital marketing agency based in Centurion, Gauteng. Quality work, honest pricing, and a local team near you.
                    </p>
                </div>
                
                <div className="footer-section" itemScope itemType="https://schema.org/LocalBusiness">
                    <h4>Find Us</h4>
                    <address className="footer-address" itemProp="address" itemScope itemType="https://schema.org/PostalAddress" style={{fontStyle:'normal',lineHeight:'1.7'}}>
                        <strong itemProp="name" style={{display:'none'}}>RDS Studio</strong>
                        <span itemProp="addressLocality">Centurion</span>,{' '}
                        <span itemProp="addressRegion">Gauteng</span>,{' '}
                        <span itemProp="postalCode">0157</span><br />
                        <span itemProp="addressCountry">South Africa</span>
                    </address>
                    <p style={{margin:'0.4rem 0'}}>
                        <a href="tel:+27846390621" itemProp="telephone" style={{color:'var(--color-accent)',textDecoration:'none'}}>+27 84 639 0621</a>
                    </p>
                    <p style={{margin:'0.4rem 0'}}>
                        <a href="mailto:info@rdsstudio.co.za" itemProp="email" style={{color:'var(--color-accent)',textDecoration:'none'}}>info@rdsstudio.co.za</a>
                    </p>
                    <p style={{margin:'0.4rem 0',fontSize:'0.85rem',opacity:0.7}}>Mon–Fri: 09:00–18:00</p>
                    <link itemProp="url" href="https://rdsstudio.co.za" />
                </div>

                <div className="footer-section">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/portfolio">Portfolio</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                        <li><Link to="/blog">Blog</Link></li>
                    </ul>
                </div>
                
                <div className="footer-section">
                    <h4>Services</h4>
                    <ul>
                        <li><Link to="/services">Web Development</Link></li>
                        <li><Link to="/services">UI/UX Design</Link></li>
                        <li><Link to="/services">Brand Strategy</Link></li>
                        <li><Link to="/services">Digital Marketing</Link></li>
                        <li><Link to="/services">SEO</Link></li>
                        <li><Link to="/services">Automation</Link></li>
                    </ul>
                </div>
                
                <div className="footer-section">
                    <h4>Newsletter</h4>
                    <p>Subscribe to our newsletter for updates and insights.</p>
                    <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                        <input 
                            type="email" 
                            placeholder="Your email" 
                            required 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isSubmitting}
                        />
                        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                        </button>
                    </form>
                    {message && (
                        <p className={`newsletter-message ${message.includes('Thank') ? 'success' : 'error'}`}>
                            {message}
                        </p>
                    )}
                    <div className="social-icons-footer">
                        <a href="https://www.facebook.com/profile.php?id=61579996723546" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://www.instagram.com/rdsstudio1111/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/jean-pierre-matthys-du-toit-7671493a3/?originalSubdomain=za" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <i className="fab fa-linkedin-in"></i>
                        </a>
                        <a href="https://www.youtube.com/channel/UCqEgC_kMwk4MqEcIC_yCayw" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <i className="fab fa-youtube"></i>
                        </a>
                    </div>
                </div>
            </div>
            
            <div className="footer-bottom">
                <p>
                    <span dangerouslySetInnerHTML={{__html: '&copy;'}} /> {currentYear} RDS Studio. All rights reserved. |{" "}
                    <Link to="/privacy-policy" style={{color:"var(--color-accent)",textDecoration:"none"}}>
                        Privacy Policy
                    </Link>{" "}
                    |{" "}
                    <Link to="/terms-of-service" style={{color:"var(--color-accent)",textDecoration:"none"}}>
                        Terms of Service
                    </Link>
                </p>
            </div>
        </footer>
    )
}

export default Footer